import { render } from "./RelatedSelect.vue?vue&type=template&id=f1610468&scoped=true"
import script from "./RelatedSelect.vue?vue&type=script&lang=js"
export * from "./RelatedSelect.vue?vue&type=script&lang=js"

import "./RelatedSelect.vue?vue&type=style&index=0&id=f1610468&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1610468"]])

export default __exports__